import { ENV } from '@/constants';
import { imgPath } from '@module/utils';
import { partialRight } from 'lodash';

export const appImgPath = partialRight(imgPath, { s3BucketUrlAssets: ENV.NEXT_PUBLIC_S3_BUCKET_URL_ASSETS });
